import { BaseErrorPage } from "./components/BaseErrorPage";

export const InvalidFileLinkError: React.FC<{ path: string }> = ({ path: _path }) => {
	return (
		<BaseErrorPage
			errorCode="404"
			title="Invalid File Link - File Not Found"
			message="Please check the link and try again,  or contact the owner of the document for support"
		/>
	);
};